import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, CreditCard } from 'lucide-react';
import { cn } from '../../utils/cn';
import type { Site } from '../../schemas/validation';

interface SitesHeaderProps {
  sites: Site[];
  currentPlan: any;
  showCreateForm: boolean;
  onShowCreateForm: () => void;
}

export const SitesHeader: React.FC<SitesHeaderProps> = ({
  sites,
  currentPlan,
  showCreateForm,
  onShowCreateForm,
}) => {
  const isAtLimit = currentPlan && currentPlan.maxSites && sites.length >= currentPlan.maxSites;

  return (
    <div className="animate-slide-up mb-6">
      <div className="bg-gradient-to-r from-primary-50 to-primary-100/50 rounded-2xl p-4 sm:p-6 border border-primary-200/50">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">Your Websites</h2>
            <p className="text-gray-600 text-sm sm:text-base">
              {sites.length === 0
                ? 'No websites yet'
                : `${sites.length} ${sites.length === 1 ? 'website' : 'websites'} created`}
              {currentPlan && currentPlan.maxSites && (
                <span
                  className={cn(
                    'ml-2',
                    sites.length >= currentPlan.maxSites ? 'text-orange-600 font-medium' : ''
                  )}
                >
                  ({sites.length}/{currentPlan.maxSites} limit)
                </span>
              )}
            </p>
          </div>
          {/* Stack buttons vertically on mobile, horizontally on larger screens */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
            <Link
              to="/pricing"
              className={cn(
                'flex items-center justify-center space-x-2 text-sm',
                currentPlan?.name === 'PROFESSIONAL' ? 'btn-ghost' : 'btn-secondary'
              )}
            >
              <CreditCard size={16} />
              <span>{currentPlan?.name === 'FREE' ? 'Upgrade Plan' : 'View Plans'}</span>
            </Link>
            {!showCreateForm && (
              <button
                onClick={onShowCreateForm}
                disabled={isAtLimit}
                className={cn(
                  'btn-primary flex items-center justify-center space-x-2',
                  isAtLimit && 'opacity-50 cursor-not-allowed'
                )}
                title={
                  isAtLimit
                    ? `Maximum websites (${currentPlan.maxSites}) reached for ${currentPlan.displayName} plan`
                    : 'Create a new website'
                }
              >
                <Plus size={20} />
                <span>Create Website</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
